import styled from 'styled-components';

const Input = styled.input`
  background: white;
  border: 1px solid #ccc;
  border-radius: 3px; 
  padding: 8px 16px;
`;

export default Input;



// WEBPACK FOOTER //
// ./src/UI/Input/Input.js